class axiosUrl {
  getAxiosUrl() {
    return process.env.BASE_URL + "api";
  }
}

export default new axiosUrl();
